import cc from "classcat"

interface SkeletonProps {
  className?: string
}

interface SkeletonTextProps {
  size?: "default" | "small"
  lines?: number
  className?: string
}

export const Skeleton = ({ className }: SkeletonProps) => {
  return <div className={cc(["skeleton", className])} />
}

export const SkeletonText = ({
  size = "default",
  lines = 3,
  className,
}: SkeletonTextProps) => {
  const blockClassName = cc(["skeleton-text", className])
  const lineClassName = `skeleton-text__line skeleton-text__line--${size}`

  return (
    <div className={blockClassName}>
      {Array(lines)
        .fill(undefined)
        .map((_, i) => (
          <div key={i} className={lineClassName}>
            <Skeleton />
          </div>
        ))}
    </div>
  )
}
